import {
  Bike,
  Boxes,
  MapPin,
  Package,
  Search,
  Truck,
  User,
} from 'lucide-react';

export const SEARCH_TYPES = [
  { id: 'all', label: 'Todo', icon: Search },
  { id: 'delivery', label: 'Lima', icon: MapPin },
  { id: 'province_delivery', label: 'Provincia', icon: Boxes },
  { id: 'express_delivery', label: 'Express', icon: Bike },
  { id: 'order', label: 'Recojos', icon: Truck },
  { id: 'user', label: 'Usuarios', icon: User },
  { id: 'package', label: 'Paquetes', icon: Package },
];

export const TYPE_STYLES = {
  delivery: {
    label: 'Entrega Lima',
    icon: MapPin,
    color: 'text-brand-primary',
    bg: 'bg-brand-primary/10',
    border: 'border-brand-primary/20',
  },
  province_delivery: {
    label: 'Entrega Provincia',
    icon: Boxes,
    color: 'text-indigo-700',
    bg: 'bg-indigo-50',
    border: 'border-indigo-100',
  },
  express_delivery: {
    label: 'Express',
    icon: Bike,
    color: 'text-emerald-700',
    bg: 'bg-emerald-50',
    border: 'border-emerald-100',
  },
  order: {
    label: 'Recojo',
    icon: Truck,
    color: 'text-amber-700',
    bg: 'bg-amber-50',
    border: 'border-amber-100',
  },
  user: {
    label: 'Usuario',
    icon: User,
    color: 'text-sky-700',
    bg: 'bg-sky-50',
    border: 'border-sky-100',
  },
  package: {
    label: 'Paquete',
    icon: Package,
    color: 'text-slate-700',
    bg: 'bg-slate-100',
    border: 'border-slate-200',
  },
};

export function formatMoney(value) {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  if (Number.isNaN(number)) return null;
  return `S/ ${number.toFixed(2)}`;
}

export function formatDate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString('es-PE', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function compactText(value, fallback = 'Sin dato') {
  if (value === null || value === undefined || value === '') return fallback;
  return String(value);
}

export function getTypeStyle(type) {
  return TYPE_STYLES[type] || TYPE_STYLES.package;
}
